module.exports = __webpack_public_path__ + "img/KSC02329.0646cbd6.jpg";